/* eslint-disable react/jsx-key */
import * as React from 'react';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { useContent, useContentContext } from '@qbe/dfc-content';
import { Button, FormGroupLabel, IconButton } from '@qbe/ads-core';
import { DetailedList } from '@qbe/ads-blocks-forms';
import FormSpacer from 'components/FormSpacer/FormSpacer';
import { InformationPopUp } from 'components';
import { isEmpty } from 'lodash';
import { AllowedFileTypesCombined } from 'pages/ComplaintComplimentFeedback/ComplaintDetailsForm/enum'; // temp
import { useTrackFiles, useTrackError } from 'hooks/useAnalytics';

interface AttachmentProps {
  maxFileSize: number;
  enabled: boolean;
  files: File[];
  setFiles: (files: File[]) => void;
  updateFiles: (newFiles: FileList) => void;
  errorMessage: string | null | undefined;
}
const Attachment = (props: AttachmentProps) => {
  const { maxFileSize, enabled, files = [], errorMessage = null, setFiles, updateFiles } = props;
  const inputFileRef = React.useRef<HTMLInputElement>(null);

  useTrackFiles(files);
  useTrackError(true, errorMessage, 'file upload');

  const { getTextContent } = useContent({
    context: useContentContext(),
  });

  // Localized content constants
  const titleText = getTextContent('attachment.title');
  const infoText = getTextContent('attachment.infoText');
  const subtitleText = getTextContent('attachment.subtitle');
  const limitText = getTextContent('attachment.limit');
  const addFilesLabel = getTextContent('attachment.addFiles');

  const handleClick = () => {
    if (!isEmpty(inputFileRef) && !isEmpty(inputFileRef.current)) {
      inputFileRef?.current?.click();
    }
  };

  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = e.target.files;
    if (!newFiles) return;
    updateFiles(newFiles);
    e.target.value = '';
  };

  const handleClose = (index: number) => () => setFiles(files.filter((_, i) => i !== index));

  if (!enabled) {
    return null;
  }

  return (
    <>
      <input
        onChange={handleFileUpload}
        ref={inputFileRef}
        type="file"
        multiple
        accept={AllowedFileTypesCombined.join(',')}
        name="files"
        data-test="file-input"
        style={{ display: 'none' }}
      />
      <FormGroupLabel
        alignCenter
        title={titleText}
        titleSuffix={<InformationPopUp message={infoText + '\n' + AllowedFileTypesCombined.join(', ')} />}
        subtitle={`${subtitleText} (${maxFileSize}${limitText})`}
      />
      <FormSpacer type="input" />
      <Button onClick={handleClick} variant="secondary-on-light" label={addFilesLabel} endIcon={<AddIcon />}></Button>
      {files.length > 0 && (
        <>
          <FormSpacer type="input" />
          <DetailedList
            sx={{ paddingY: 0 }}
            list={files.map(
              (item, index) => ({
                id: item.name,
                label: item.name,
                name: item.name,
                value: '',
                stackActions: () => <IconButton iconProps={{ muiIcon: CloseIcon }} onClick={handleClose(index)} />,
              }),
              {}
            )}
            variant="stack"
          />
        </>
      )}
      {errorMessage && <span style={{ color: '#a50000' }}>{errorMessage}</span>}
    </>
  );
};

export default Attachment;
